module.exports = __webpack_public_path__ + "static/media/forgot-password-questionmarks.6b854f15.svg";